import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'searchFilter',
    standalone: false
})

export class SearchTermFilterPipe implements PipeTransform {
    transform(items: any[], filterTerms: any[], property: string): any[] {
        if (!items) return [];
        if (!filterTerms) return items;
        if (filterTerms.length <= 0) return [];
        if (!property) return items;
        

        return items.filter(it => {
            return filterTerms.includes(it[property]);
        });
    }
}


@Pipe({
    name: 'excludeItems',
    standalone: false
})

export class ExcludeItemsPipe implements PipeTransform {
    transform(items: any[], excludeTerms: any[], property: string): any[] {
        if (!items) return [];
        if (!excludeTerms) return items;
        if (excludeTerms.length <= 0) return [];
        if (!property) return items;

        return items.filter(it => {
            return !excludeTerms.includes(it[property]);
        })
    }
}
